import { api } from "../../http";

async function PostDataItem(data) {
  try {
    
    const resp = await api.post(`/items`,data);
    return resp;


  } catch (e) {
    console.log(e.message);
  }
}

export { PostDataItem };
